import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "flow-left",
  "use": "flow-left-usage",
  "viewBox": "0 0 19 18",
  "content": "<symbol viewBox=\"0 0 19 18\" xmlns=\"http://www.w3.org/2000/svg\" id=\"flow-left\"><title>Flow</title><g stroke-width=\"3.2\" fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M8.8 15.588L2.012 8.8 8.8 2.012M16.8 15.588L10.012 8.8 16.8 2.012\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/wc-lib/icons/flow-left.svg
// module id = 519
// module chunks = 0